import * as React from 'react'
import { InputNumber } from 'antd-v4'

interface Props {
  value?: number
  min?: number
  max?: number
  disabled?: boolean
  style?: React.CSSProperties
  className?: string
  onChange: (value: number | string | undefined) => void
}

export const PercentageInput = (props: Props) => (
  <InputNumber
    min={props.min}
    max={props.max}
    value={props.value}
    className={props.className}
    style={props.style}
    formatter={(value) => {
      if (value === undefined) return ''

      const isNegative = value[0] === '-'
      const cleanedValue = `${value}`.replace(/[^0-9.]/g, '')

      return 0 <= Number(cleanedValue) ? `${isNegative ? '-' : ''}${cleanedValue}%` : ''
    }}
    parser={(value) => (value || '').replace('%', '')}
    onChange={props.onChange}
    disabled={props.disabled}
  />
)
